export default "__VITE_ASSET__AONTEoDG__"